/** THIS FILE IS AUTOGENERATED. DO NOT EDIT. */
import type { IconProps } from './types/index';

function IcRefreshRegular({ className, ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 24 24"
      className={`kc-console-icon ${className ? className : ''}`}
      {...props}
    >
      <path d="M12.343 4.9a7.1 7.1 0 0 0-6.348 3.915h2.576a.9.9 0 0 1 0 1.8H4a.9.9 0 0 1-.9-.9V5.143a.9.9 0 0 1 1.8 0V7.12a8.904 8.904 0 0 1 15.974 2.339.9.9 0 0 1-1.725.513 7.1 7.1 0 0 0-6.806-5.07m-7.926 8.521a.9.9 0 0 1 1.12.606 7.104 7.104 0 0 0 13.153 1.157h-2.576a.9.9 0 1 1 0-1.8h4.571a.9.9 0 0 1 .9.9v4.571a.9.9 0 1 1-1.8 0v-1.975a8.904 8.904 0 0 1-15.974-2.34.9.9 0 0 1 .606-1.119" />
    </svg>
  );
}
export default IcRefreshRegular;
